<template>
  <div id="app">
    <router-view v-if="baseConfigLoaded" />
  </div>
</template>

<script>
import store from "./store";
import { getBaseConfig } from "@/api/setting";
import methodCommon from "@/utils/methodCommon";

export default {
  name: "App",
  data() {
    return {
      baseConfigLoaded: false,
    };
  },
  created() {
    // 取得 title、image 等信息，来区分 RA、RX、大胖、二胖
    getBaseConfig()
      .then((res) => {
        // 写入 store
        store.state.app.switchProjectObj = {
          title: JSON.parse(res.data.config).title
            ? JSON.parse(res.data.config).title
            : "",
          img: JSON.parse(res.data.config).image
            ? JSON.parse(res.data.config).image
            : "",
        };
        document.title = `${store.state.app.switchProjectObj.title} ${
          store.state.app.userInfo
            ? methodCommon.methods.translateUserType(
                store.state.app.userInfo.userType
              )
            : ""
        }`;

        // 让替换 icon 只作用在正式环境，避免因为打包判断测、正式环境两套逻辑打架
        if (document.querySelector("link[rel~='icon']").href.includes("icon")) {
          document.querySelector("link[rel~='icon']").href = `/${
            JSON.parse(res.data.config).icon
          }`;
        }

        this.baseConfigLoaded = true;
      })
      .catch(() => {});
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue